import App from './App.vue';

export default {
  path: '/CDS_VF_EvacuationAdvisoryDetail',
  name: 'CDS_VF_EvacuationAdvisoryDetail',
  component: App,
  meta: {
    pageProperty: {
      title: '避難情報発表詳細',
      controller: 'CDS_CTR_EvacuationAdvisoryDetail',
    },
  },
};
